import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { FDSwitchInput } from '@facet-wealth/design';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { useAuthenticationFactorListContext } from '../../AuthenticationFactorListContext';

const getSwitchProps = (factorResource) => {
  const registerSwitchProps = factorResource.withRelationship(fr.relationships.authenticationFactorRegister.name, (rel) => {
    return {
      action: 'register',
      relationship: rel,
      analyticsEventName: 'enable',
    };
  }, () => null);

  if (registerSwitchProps) {
    return registerSwitchProps;
  }

  const disableSwitchProps = factorResource.withRelationship(fr.relationships.authenticationFactorModify.name, (rel) => {
    return {
      action: 'disable',
      relationship: rel,
      analyticsEventName: 'disable',
    };
  }, () => null);

  if (disableSwitchProps) {
    return disableSwitchProps;
  }

  // This means we aren't able to help you make changes right now
  return {
    disabled: true,
  };
};

const AuthenticationFactorListItemActionOptional = ({
  authenticationFactorResource: factorResource,
}) => {
  const { setModalLink } = useAuthenticationFactorListContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const switchProps = getSwitchProps(factorResource);

  return (
    <FDSwitchInput
      {...dataAttrs('authentication factor', factorResource, {
        [testAttr.dataAction]: switchProps.action,
      })}
      disabled={switchProps.disabled}
      value={factorResource.isTruthy('enabled')}
      onChange={() => {
        logStandardizedEvent(
          categories.userSettingsSecurity,
          eventTypes.clickButton,
          `${switchProps.analyticsEventName} factor`,
          {
            eventProperties: {
              authFactorType: factorResource.attr('authenticationType'),
            },
          },
        );
        setModalLink(switchProps.relationship.link('related'));
      }}
      size={'sm'}
      data-test={`security-settings-switch-register-${factorResource.attr('authenticationType')}-${factorResource.isTruthy('enabled') ? 'enabled' : 'disabled'}`}
    />
  );
};

AuthenticationFactorListItemActionOptional.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItemActionOptional;
